import React from 'react';
export function Header() {
  return <header className="w-full bg-white shadow-sm sticky top-0 z-50" data-id="element-150">
      <div className="max-w-[1200px] mx-auto px-6" data-id="element-151">
        <div className="flex justify-between items-center py-4 md:justify-start md:space-x-10" data-id="element-152">
          <div className="flex justify-start lg:w-0 lg:flex-1" data-id="element-153">
            <a href="#" data-id="element-154">
              <span className="sr-only" data-id="element-155">Setu</span>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/myjTVrir1QdMGKZoaP2e2j/Screenshot_2025-08-06_at_12.37.31_PM.png" alt="Setu Logo" className="h-12 w-auto" data-id="element-156" />
            </a>
          </div>
          <nav className="hidden md:flex space-x-10" data-id="element-157">
            <a href="#" className="text-base font-medium text-[#2C3E50] hover:text-[#1B2951] font-['Inter']" data-id="element-158">
              Home
            </a>
            <a href="#" className="text-base font-medium text-[#2C3E50] hover:text-[#1B2951] font-['Inter']" data-id="element-159">
              Shop
            </a>
            <a href="#" className="text-base font-medium text-[#2C3E50] hover:text-[#1B2951] font-['Inter']" data-id="element-160">
              About
            </a>
          </nav>
        </div>
      </div>
      <div className="bg-[#FFE5D9] py-3 px-6" data-id="element-161">
        <div className="max-w-[1200px] mx-auto" data-id="element-162">
          <div className="flex items-center justify-center" data-id="element-163">
            <p className="text-sm text-[#7F8C8D] mr-4 hidden sm:block font-['Inter']" data-id="element-164">
              Featured in:
            </p>
            <div className="flex items-center justify-between space-x-4 sm:space-x-8 overflow-x-auto py-1 w-full sm:w-auto" data-id="element-165">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1SM8dZdsf6tTWMR6A7XCJc/Screenshot_2025-08-06_at_12.37.52_PM.png" alt="Featured in Vogue, YourStory, Business Standard, ELLE, and The Economic Times" className="h-6 sm:h-8 w-auto" data-id="element-166" />
            </div>
          </div>
        </div>
      </div>
    </header>;
}